export default __webpack_public_path__ + "static/media/github.3113a96d.svg";